<div class="in2">

  <div class="in2-state" *ngIf="status === 'sem_projeto'">
    <i class="fas fa-chart-line"></i>
    <h3>Analytics não configurado</h3>
    <p>O projeto de analytics ainda não foi configurado para esta loja.</p>
  </div>

  <div class="in2-state in2-state-erro" *ngIf="status === 'erro'">
    <i class="fas fa-exclamation-triangle"></i>
    <h3>Não foi possível carregar</h3>
    <p>{{ erroMensagem }}</p>
    <button type="button" (click)="carregue()">Tentar novamente</button>
  </div>

  <div class="in2-skeleton" *ngIf="status === 'carregando'" role="status" aria-label="Carregando resultados">
    <span class="in2-sk in2-sk-bar"></span>
    <span class="in2-sk in2-sk-hero"></span>
    <span class="in2-sk in2-sk-funnel"></span>
    <div class="in2-sk-row"><span class="in2-sk"></span><span class="in2-sk"></span></div>
  </div>

  <ng-container *ngIf="status === 'pronto'">
    <div class="in2-refresh" *ngIf="carregando"><span class="in2-spinner"></span></div>

    <!-- Barra fixa -->
    <header class="in2-bar">
      <div class="in2-bar-title">
        <h1><i class="fas fa-chart-line" aria-hidden="true"></i>Resultados do Cardápio</h1>
        <span>{{ obtenhaLabelPeriodo() }} · {{ obtenhaIntervaloDatas() }} · {{ obtenhaTextoAtualizacao() }}</span>
      </div>
      <div class="in2-bar-actions">
        <span class="in2-live" [class.ativo]="obtenhaLive() > 0" title="Visitantes no cardápio agora">
          <i></i>{{ obtenhaLive() | number }} agora
        </span>
        <app-periodo-segmentado
          [periodos]="periodos"
          [selecionado]="quickDateFilter"
          [disabled]="carregando"
          (periodoSelecionado)="selecionePreset($event)">
        </app-periodo-segmentado>
        <button type="button" class="in2-ghost" (click)="exportarCSV('funnel')"><i class="fas fa-download"></i>Planilha</button>
      </div>
    </header>

    <ng-template #blocoFunil>
    <!-- Funil: etapas coladas, onda contínua, passagem nas emendas -->
    <section class="in2-funnel" aria-label="Funil de conversão">
      <div class="in2-funnel-band">
        <div class="in2-stage" *ngFor="let etapa of etapas; let i = index">
          <div class="in2-stage-top">
            <span class="in2-stage-label">{{ etapa.label }}</span>
            <strong class="in2-num">{{ etapa.count | number }}</strong>
            <span class="in2-stage-desc">{{ etapa.desc }}</span>
            <span class="in2-stage-extra" *ngIf="etapa.key === 'visualizacoes' && detalheVisualizacoes">{{ detalheVisualizacoes }}</span>
            <span class="in2-stage-extra" *ngIf="etapa.detalhe">{{ etapa.detalhe }}</span>
            <span class="in2-stage-var" [ngClass]="etapa.variacaoClasse" *ngIf="etapa.variacaoTexto">{{ etapa.variacaoTexto }}</span>
          </div>
          <div class="in2-wave">
            <svg viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
              <defs>
                <linearGradient [attr.id]="'in2-grad-' + i" x1="0%" y1="0%" x2="0%" y2="100%">
                  <stop offset="0%" [attr.stop-color]="etapa.cor"></stop>
                  <stop offset="100%" [attr.stop-color]="etapa.corFinal"></stop>
                </linearGradient>
              </defs>
              <path [attr.d]="obtenhaWavePath(i)" [attr.fill]="'url(#in2-grad-' + i + ')'"></path>
            </svg>
            <span class="in2-wave-percent" [style.top]="obtenhaOffsetPercent(i)" [ngClass]="obtenhaClassePercent(i)">{{ etapa.percent | number:'1.0-0' }}%</span>
          </div>
        </div>
        <div class="in2-joints" aria-label="Passagem entre etapas">
          <div class="in2-joint" *ngFor="let junta of juntas; let i = index" [ngClass]="'saude-' + junta.saude" [style.left.%]="(i + 1) * 20">
            <span class="in2-joint-chip" title="seguem para a próxima etapa">
              <strong>{{ junta.percent == null ? '—' : ((junta.percent | number:'1.0-0') + '%') }}</strong>
              <svg class="in2-joint-seta" viewBox="0 0 28 10" aria-hidden="true"><path d="M1 5h24m-4.5-3.5L25 5l-4.5 3.5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </span>
            <em *ngIf="junta.gargalo">maior gargalo</em>
          </div>
        </div>
      </div>
    </section>

    <!-- Passagem e tempo entre etapas, explícitos -->
    <div class="in2-seams-row">
      <section class="in2-card in2-passagens" aria-label="Passagem entre etapas">
        <header>
          <h3>Passagem entre etapas</h3>
          <p>Quem seguiu de uma etapa para a próxima</p>
        </header>
        <div class="in2-seam-cols">
          <div *ngFor="let junta of juntas" [ngClass]="'saude-' + junta.saude">
            <span class="in2-seam-ico" [style.background]="junta.cor + '1c'" [style.color]="junta.cor"><i [ngClass]="junta.icone" aria-hidden="true"></i></span>
            <div class="in2-seam-body">
              <span>{{ junta.de }} → {{ junta.para }}</span>
              <strong class="in2-num">{{ junta.percent == null ? '—' : ((junta.percent | number:'1.0-0') + '%') }}</strong>
              <div class="in2-passagem-bar"><b [style.width.%]="junta.percent || 0"></b></div>
              <small *ngIf="junta.percent != null">{{ junta.paraCount | number }} de {{ junta.deCount | number }} visitas</small>
              <em *ngIf="junta.gargalo">maior gargalo</em>
            </div>
          </div>
        </div>
        <p class="in2-nota" *ngIf="!temAmostraSuficiente()">Abaixo do volume mínimo — taxas indicativas.</p>
      </section>

      <section class="in2-card in2-timeline" aria-label="Tempo de decisão do cliente" *ngIf="obtenhaLinhaTempo() as linha">
        <header>
          <h3>Tempo de decisão do cliente</h3>
          <p>Quanto tempo leva cada trecho do funil, dentro da mesma visita</p>
        </header>
        <div class="in2-timeline-hero">
          <strong class="in2-num">{{ linha.total }}</strong>
          <span>{{ linha.apoio }}</span>
        </div>
        <div class="in2-timeline-bar" aria-hidden="true">
          <b *ngFor="let seg of linha.segmentos" [style.width.%]="seg.percent" [style.background]="seg.cor"></b>
        </div>
        <div class="in2-timeline-ticks" aria-hidden="true">
          <span class="inicio">0s</span>
          <span *ngFor="let seg of linha.segmentos; let ultimo = last" [style.left.%]="seg.fimPercent" [class.fim]="ultimo" [class.oculto]="!seg.mostraTick">{{ seg.acumulado }}</span>
        </div>
        <div class="in2-seam-cols">
          <div *ngFor="let seg of linha.segmentos">
            <span class="in2-seam-ico" [style.background]="seg.cor + '1c'" [style.color]="seg.cor"><i [ngClass]="seg.icone" aria-hidden="true"></i></span>
            <div class="in2-seam-body">
              <span>{{ seg.rotulo }}</span>
              <strong class="in2-num">{{ seg.tempo }}</strong>
              <small>{{ seg.percent | number:'1.0-0' }}% do tempo</small>
              <em *ngIf="seg.maior">maior tempo</em>
            </div>
          </div>
        </div>
        <p class="in2-nota">{{ linha.nota }}</p>
      </section>
    </div>

    <!-- Leitura do período -->
    <section class="in2-hero">
      <div class="in2-hero-copy">
        <span class="in2-eyebrow">Leitura do período</span>
        <h2>{{ leitura.frase }}</h2>
        <p>{{ leitura.apoio }}</p>
      </div>
    </section>

    <!-- As perguntas do dono, uma por card -->
    <section class="in2-owner-grid" aria-label="Resumo do período">
      <article class="in2-owner-card" *ngFor="let card of obtenhaCardsDono()" [class.texto]="card.texto" [class.verde]="$any(card).verde">
        <span>{{ card.rotulo }}</span>
        <strong [class.in2-num]="!card.texto">{{ card.valor }}</strong>
        <small [ngClass]="card.tom || ''">{{ card.detalhe }}</small>
        <svg class="in2-owner-spark" *ngIf="$any(card).spark" viewBox="0 0 100 28" preserveAspectRatio="none" aria-hidden="true">
          <path [attr.d]="$any(card).spark" [attr.stroke]="$any(card).sparkCor"></path>
        </svg>
      </article>
    </section>

    <!-- Movimento do período + onde agir -->
    <div class="in2-overview-row">
      <article class="in2-card">
        <header><h3>Movimento do período</h3><p>Visitas e pedidos por dia</p></header>
        <div class="in2-chart" *ngIf="temSerieVisitas; else semMovimento">
          <kendo-chart [transitions]="false">
            <kendo-chart-category-axis><kendo-chart-category-axis-item [categories]="categoriasSerie" [majorTicks]="{ visible: false }" [majorGridLines]="{ visible: false }" [labels]="{ step: obtenhaStepRotulos(), font: '10px Poppins', color: '#8a93ad' }"></kendo-chart-category-axis-item></kendo-chart-category-axis>
            <kendo-chart-value-axis><kendo-chart-value-axis-item [min]="0" [max]="obtenhaMaximoMovimento()" [line]="{ visible: false }" [labels]="{ font: '10px Poppins', color: '#8a93ad' }"></kendo-chart-value-axis-item></kendo-chart-value-axis>
            <kendo-chart-series>
              <kendo-chart-series-item type="line" name="Visitas" [data]="serieVisitas" color="#5b4bed" [markers]="{ visible: false }" [width]="2"></kendo-chart-series-item>
              <kendo-chart-series-item type="line" name="Pedidos" [data]="seriePedidos" color="#0fa96b" [markers]="{ visible: false }" [width]="2"></kendo-chart-series-item>
            </kendo-chart-series>
            <kendo-chart-tooltip [visible]="true"><ng-template kendoChartSeriesTooltipTemplate let-value="value" let-category="category" let-series="series"><div class="in2-tooltip"><strong>{{ category }}</strong><span>{{ value | number }} {{ (series?.name || '').toLowerCase() }}</span></div></ng-template></kendo-chart-tooltip>
            <kendo-chart-legend [visible]="true" position="bottom" [labels]="{ font: '11px Poppins', color: '#6b7591' }"></kendo-chart-legend>
          </kendo-chart>
        </div>
        <ng-template #semMovimento><div class="in2-vazio">Sem visitas registradas no período</div></ng-template>
      </article>
      <aside class="in2-card in2-attn-card">
        <header><h3>Vale sua atenção</h3><p>Onde agir primeiro</p></header>
        <button type="button" class="in2-attn" *ngFor="let item of obtenhaAtencaoAgora()" [ngClass]="'tom-' + item.tom" (click)="selecioneAba(item.aba)">
          <div><strong>{{ item.titulo }}</strong><p>{{ item.descricao }}</p></div>
          <i class="fas fa-chevron-right"></i>
        </button>
        <p class="in2-nota" *ngIf="!obtenhaAtencaoAgora().length">Nada crítico agora — siga acompanhando.</p>
      </aside>
    </div>

    </ng-template>

    <!-- Zona de exploração -->
    <nav class="in2-tabs" role="tablist">
      <button type="button" *ngFor="let aba of abas" role="tab"
        [attr.aria-selected]="abaAtiva === aba.id"
        [class.ativa]="abaAtiva === aba.id"
        (click)="selecioneAba(aba.id)">{{ aba.label }}</button>
    </nav>

    <section class="in2-panel" [ngSwitch]="abaAtiva">

      <!-- VISAO GERAL -->
      <div *ngSwitchCase="'visao'">
        <ng-container *ngTemplateOutlet="blocoFunil"></ng-container>
      </div>

      <!-- TENDENCIA -->
      <div *ngSwitchCase="'tendencia'">
      <div class="in2-trend">
        <article class="in2-card">
          <header><h3>Visitas por dia</h3><p>Quantas pessoas entraram no cardápio</p></header>
          <div class="in2-chart" *ngIf="temSerieVisitas; else semVisitas">
            <kendo-chart [transitions]="false">
              <kendo-chart-category-axis><kendo-chart-category-axis-item [categories]="categoriasSerie" [majorTicks]="{ visible: false }" [majorGridLines]="{ visible: false }" [labels]="{ step: obtenhaStepRotulos(), font: '10px Poppins', color: '#8a93ad' }"></kendo-chart-category-axis-item></kendo-chart-category-axis>
              <kendo-chart-value-axis><kendo-chart-value-axis-item [min]="0" [max]="obtenhaMaximoVisitas()" [line]="{ visible: false }" [labels]="{ font: '10px Poppins', color: '#8a93ad' }"></kendo-chart-value-axis-item></kendo-chart-value-axis>
              <kendo-chart-series><kendo-chart-series-item type="line" [data]="serieVisitas" color="#5b4bed" [markers]="{ visible: false }" [width]="2"></kendo-chart-series-item></kendo-chart-series>
              <kendo-chart-tooltip [visible]="true"><ng-template kendoChartSeriesTooltipTemplate let-value="value" let-category="category"><div class="in2-tooltip"><strong>{{ category }}</strong><span>{{ value | number }} visitas</span></div></ng-template></kendo-chart-tooltip>
              <kendo-chart-legend [visible]="false"></kendo-chart-legend>
            </kendo-chart>
          </div>
          <ng-template #semVisitas><div class="in2-vazio">Sem visitas registradas no período</div></ng-template>
        </article>
        <article class="in2-card">
          <header><h3>Conversão por dia</h3><p>Visitas que viraram pedido</p></header>
          <div class="in2-chart" *ngIf="temSerieConversao; else semConversao">
            <kendo-chart [transitions]="false">
              <kendo-chart-category-axis><kendo-chart-category-axis-item [categories]="categoriasSerie" [majorTicks]="{ visible: false }" [majorGridLines]="{ visible: false }" [labels]="{ step: obtenhaStepRotulos(), font: '10px Poppins', color: '#8a93ad' }"></kendo-chart-category-axis-item></kendo-chart-category-axis>
              <kendo-chart-value-axis><kendo-chart-value-axis-item [min]="0" [max]="obtenhaMaximoConversao()" [line]="{ visible: false }" [labels]="{ font: '10px Poppins', color: '#8a93ad', format: '{0}%' }"></kendo-chart-value-axis-item></kendo-chart-value-axis>
              <kendo-chart-series><kendo-chart-series-item type="line" [data]="serieConversao" color="#0fa96b" [markers]="{ visible: false }" [width]="2"></kendo-chart-series-item></kendo-chart-series>
              <kendo-chart-tooltip [visible]="true"><ng-template kendoChartSeriesTooltipTemplate let-value="value" let-category="category"><div class="in2-tooltip"><strong>{{ category }}</strong><span>{{ value | number:'1.0-1' }}% de conversão</span></div></ng-template></kendo-chart-tooltip>
              <kendo-chart-legend [visible]="false"></kendo-chart-legend>
            </kendo-chart>
          </div>
          <ng-template #semConversao><div class="in2-vazio">Nenhum pedido concluído no período</div></ng-template>
        </article>
      </div>

      <div class="in2-behavior">
        <article class="in2-card">
          <header><h3>Novos vs. recorrentes</h3><p>Recorrente = também visitou no período anterior</p></header>
          <div class="in2-behavior-nums">
            <div><span>Visitantes únicos</span><strong class="in2-num">{{ (analyticsResumo?.visitasUnicas || 0) | number }}</strong></div>
            <div><span>Novos</span>
              <ng-container *ngIf="obtenhaNovosVisitantes() != null; else novosInstrumentacao"><strong class="in2-num">{{ obtenhaNovosVisitantes() | number }}</strong><small *ngIf="obtenhaPercentualVisitantes(obtenhaNovosVisitantes()) != null">{{ obtenhaPercentualVisitantes(obtenhaNovosVisitantes()) | number:'1.0-0' }}% dos visitantes</small></ng-container>
              <ng-template #novosInstrumentacao><strong class="in2-num">—</strong><small>sem período anterior comparável</small></ng-template>
            </div>
            <div><span>Recorrentes</span>
              <ng-container *ngIf="obtenhaVisitantesRecorrentes() != null; else recorrentesInstrumentacao"><strong class="in2-num">{{ obtenhaVisitantesRecorrentes() | number }}</strong><small *ngIf="obtenhaPercentualVisitantes(obtenhaVisitantesRecorrentes()) != null">{{ obtenhaPercentualVisitantes(obtenhaVisitantesRecorrentes()) | number:'1.0-0' }}% dos visitantes</small></ng-container>
              <ng-template #recorrentesInstrumentacao><strong class="in2-num">—</strong><small>sem período anterior comparável</small></ng-template>
            </div>
          </div>
        </article>
        <article class="in2-card">
          <header><h3>Tempo por etapa</h3><p>Tempo médio entre um passo e o seguinte, na mesma visita</p></header>
          <ng-container *ngIf="temTemposEtapas(); else temposInstrumentacao">
            <div class="in2-tempo-row" *ngFor="let tempo of obtenhaTemposEtapas()">
              <span>{{ tempo.rotulo }}</span>
              <div class="in2-tempo-valor">
                <strong>{{ tempo.tempo || '—' }}</strong>
                <small *ngIf="tempo.variacao" [ngClass]="tempo.variacaoClasse">{{ tempo.variacao }}</small>
              </div>
            </div>
            <p class="in2-nota">Calculado sobre visitas que chegaram às duas etapas.</p>
          </ng-container>
          <ng-template #temposInstrumentacao>
            <div class="in2-tempo-row" *ngFor="let tempo of temposEtapas"><span>{{ tempo }}</span><strong>—</strong></div>
            <p class="in2-nota">Ainda sem visitas que percorreram etapas consecutivas no período.</p>
          </ng-template>
        </article>
        <article class="in2-card">
          <header><h3>Pico de visitas</h3><p>Dia de maior movimento no período</p></header>
          <strong class="in2-pico">{{ obtenhaPicoVisitas().titulo }}</strong>
          <p class="in2-nota">{{ obtenhaPicoVisitas().descricao }}</p>
        </article>
      </div>

      <!-- Métricas técnicas de analytics -->
      <section class="in2-metrics" aria-label="Métricas de analytics">
        <div *ngFor="let metrica of obtenhaMetricasSecundarias()">
          <span>{{ metrica.label }}</span>
          <strong class="in2-num">{{ metrica.texto }}</strong>
          <small>{{ metrica.nota }}</small>
        </div>
      </section>
      </div>

      <!-- CARDAPIO -->
      <div class="in2-menu" *ngSwitchCase="'cardapio'">
        <article class="in2-card in2-menu-table">
          <header class="in2-menu-head">
            <div><h3>Desempenho dos produtos</h3><p>O que desperta interesse e o que vende</p></div>
            <div class="in2-menu-tools">
              <label class="in2-search"><i class="fas fa-search"></i><input type="search" placeholder="Buscar produto" [value]="buscaProduto" (input)="filtreProdutos($any($event.target).value)"></label>
              <button type="button" class="in2-ghost" (click)="exportarCSV('produtos')"><i class="fas fa-download"></i>Planilha</button>
            </div>
          </header>
          <div class="in2-table-wrap">
            <table class="in2-table">
              <thead><tr><th>Produto</th><th>Viram</th><th>Sacola</th><th>Pedidos</th><th>Receita</th></tr></thead>
              <tbody>
                <tr *ngFor="let p of obtenhaProdutosPaginados()">
                  <td><span class="in2-avatar">{{ obtenhaInicial(p) }}</span><span class="in2-prod-nome">{{ p.title }}</span></td>
                  <td><div class="in2-cell"><strong>{{ p.uniqueViews | number }}</strong><small>{{ p.views | number }} views</small></div></td>
                  <td><div class="in2-cell"><strong>{{ p.addToCart | number }}</strong><small *ngIf="obtenhaTaxaSacola(p) != null">{{ obtenhaTaxaSacola(p) | number:'1.0-0' }}% dos que viram</small></div></td>
                  <td><div class="in2-cell"><strong>{{ p.pedidos | number }}</strong><small *ngIf="obtenhaTaxaPedido(p) != null">{{ obtenhaTaxaPedido(p) | number:'1.0-0' }}% dos que viram</small></div></td>
                  <td class="in2-dim">—</td>
                </tr>
                <tr *ngIf="!obtenhaProdutosFiltrados().length"><td colspan="5" class="in2-vazio-linha">Nenhum produto encontrado.</td></tr>
              </tbody>
            </table>
          </div>
          <footer class="in2-table-foot">
            <span>{{ obtenhaIntervaloProdutos() }}</span>
            <div>
              <button type="button" (click)="selecionePagina(paginaProdutos - 1)" [disabled]="paginaProdutos <= 1" aria-label="Página anterior"><i class="fas fa-chevron-left"></i></button>
              <button type="button" (click)="selecionePagina(paginaProdutos + 1)" [disabled]="paginaProdutos >= obtenhaTotalPaginas()" aria-label="Próxima página"><i class="fas fa-chevron-right"></i></button>
            </div>
          </footer>
        </article>
        <aside class="in2-card in2-ranks">
          <div class="in2-rank-group" *ngFor="let grupo of gruposRanking">
            <h4>{{ grupo.titulo }}</h4>
            <div class="in2-rank-item" *ngFor="let p of obtenhaTopPor(grupo.campo); let i = index">
              <span class="in2-rank-pos" [class.lider]="i === 0">{{ i + 1 }}</span>
              <div><span>{{ p.title }}</span><i><b [style.width.%]="obtenhaPercentualRanking(p, obtenhaTopPor(grupo.campo), grupo.campo)"></b></i></div>
              <strong>{{ (p[grupo.campo] || 0) | number }}</strong>
            </div>
            <p class="in2-nota" *ngIf="!obtenhaTopPor(grupo.campo).length">Sem movimento no período.</p>
          </div>
          <div class="in2-lider" *ngIf="obtenhaLiderPedidos() as lider">
            <i class="fas fa-chart-line"></i>
            <p><strong>{{ lider.title }}</strong> lidera em pedidos no período.</p>
          </div>
        </aside>
      </div>

      <!-- CANAIS -->
      <div *ngSwitchCase="'origens'">
      <section class="in2-canais-kpis" aria-label="Resultado dos canais">
        <article class="in2-card" *ngFor="let kpi of obtenhaKpisCanais()">
          <span class="in2-kpi-icon" [ngClass]="kpi.classe"><i [ngClass]="kpi.icone"></i></span>
          <div><span>{{ kpi.label }}</span><strong class="in2-num">{{ kpi.valor }}</strong><small>{{ kpi.nota }}</small></div>
        </article>
      </section>
      <div class="in2-sources">
        <article class="in2-card">
          <header><h3>De onde vêm as visitas</h3><p>Canal das sessões e quanto cada um vende</p></header>
          <div class="in2-table-wrap">
            <table class="in2-table">
              <thead><tr><th>Canal</th><th>Visitas</th><th>Pedidos</th><th>Receita</th></tr></thead>
              <tbody>
                <tr *ngFor="let fonte of fontes.slice(0, 8)" class="in2-canal-row" [class.selecionada]="obtenhaFonteDetalhe()?.nome === fonte.nome" (click)="selecioneFonte(fonte)">
                  <td><span class="in2-source-icon" [ngClass]="fonte.classe"><i [ngClass]="fonte.icone"></i></span><span class="in2-source-nome">{{ fonte.nome }}</span></td>
                  <td><div class="in2-cell"><strong>{{ fonte.contagem | number }}</strong><small>{{ fonte.share | number:'1.0-0' }}% do total</small></div></td>
                  <ng-container *ngIf="fontesComVendas; else colunasSemVendas">
                    <td><div class="in2-cell"><strong>{{ fonte.pedidos | number }}</strong><small *ngIf="fonte.conversao != null">{{ fonte.conversao | number:'1.0-1' }}% das visitas</small></div></td>
                    <td>
                      <div class="in2-cell" *ngIf="fonte.receita != null; else traco">
                        <strong>{{ formateMoeda(fonte.receita) }}</strong>
                        <small *ngIf="fonte.ticketMedio != null">ticket {{ formateMoeda(fonte.ticketMedio) }}</small>
                      </div>
                    </td>
                  </ng-container>
                  <ng-template #colunasSemVendas>
                    <td class="in2-dim">—</td>
                    <td class="in2-dim">—</td>
                  </ng-template>
                  <ng-template #traco><span class="in2-dim">—</span></ng-template>
                </tr>
                <tr *ngIf="!fontes.length"><td colspan="4" class="in2-vazio-linha">Nenhum canal identificado no período.</td></tr>
              </tbody>
            </table>
          </div>
          <div class="in2-canal-funil" *ngIf="obtenhaFonteDetalhe() as canalDetalhe">
            <header class="in2-canal-funil-head">
              <h4>Funil do canal · {{ canalDetalhe.nome }}</h4>
              <small>Clique em um canal na tabela para detalhar</small>
            </header>
            <ng-container *ngIf="obtenhaPassagensFonte(canalDetalhe).length; else canalSemFunil">
              <div class="in2-seam-cols">
                <div *ngFor="let junta of obtenhaPassagensFonte(canalDetalhe)" [ngClass]="'saude-' + junta.saude">
                  <span class="in2-seam-ico" [style.background]="junta.cor + '1c'" [style.color]="junta.cor"><i [ngClass]="junta.icone" aria-hidden="true"></i></span>
                  <div class="in2-seam-body">
                    <span>{{ junta.de }} → {{ junta.para }}</span>
                    <strong class="in2-num">{{ junta.percent == null ? '—' : ((junta.percent | number:'1.0-0') + '%') }}</strong>
                    <div class="in2-passagem-bar"><b [style.width.%]="junta.percent || 0"></b></div>
                    <small *ngIf="junta.percent != null">{{ junta.paraCount | number }} de {{ junta.deCount | number }}</small>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-template #canalSemFunil><p class="in2-nota">Funil por canal disponível após atualizar o servidor.</p></ng-template>
          </div>
          <p class="in2-nota" *ngIf="fontes.length && !fontesComVendas">Pedidos, conversão e receita por canal estão em instrumentação.</p>
          <p class="in2-nota" *ngIf="obtenhaCoberturaReceita() as cobertura">Receita calculada sobre os pedidos que informaram valor ({{ cobertura.comValor }} de {{ cobertura.pedidos }}).</p>
        </article>
        <aside class="in2-card">
          <header><h3>Canal líder</h3><p>{{ fontesComVendas ? 'Quem mais vende no período' : 'Mais visitas no período' }}</p></header>
          <div class="in2-lider" *ngIf="obtenhaLiderCanais() as lider">
            <i class="fas fa-star"></i>
            <p *ngIf="fontesComVendas && lider.receita != null; else liderVisitas"><strong>{{ lider.nome }}</strong> lidera as vendas com {{ formateMoeda(lider.receita) }} neste período.</p>
            <ng-template #liderVisitas><p><strong>{{ lider.nome }}</strong> lidera as visitas identificadas neste período.</p></ng-template>
          </div>
          <p class="in2-nota" *ngIf="!fontes.length">Sem canais identificados ainda.</p>
          <div class="in2-atrib">
            <strong>Atribuição</strong>
            <div>
              <button type="button" disabled>Primeiro contato</button>
              <button type="button" class="ativa" disabled>Último contato</button>
            </div>
            <p class="in2-nota">{{ fontesComVendas ? 'Vendas atribuídas ao contato mais recente da visita.' : 'Escolha disponível quando a venda por canal estiver instrumentada.' }}</p>
          </div>
        </aside>
      </div>
      </div>

      <!-- DIAGNOSTICO -->
      <div *ngSwitchCase="'diagnostico'">
      <div class="in2-diag">
        <article class="in2-card">
          <header><h3>Confiança do diagnóstico</h3><p>Volume mínimo para apontar gargalo: {{ amostraMinima }} visitas</p></header>
          <div class="in2-amostra">
            <div class="in2-amostra-bar"><b [style.width.%]="obtenhaProgressoAmostra()" [class.completa]="temAmostraSuficiente()"></b></div>
            <span>{{ (etapas[0]?.count || 0) | number }} de {{ amostraMinima }} visitas</span>
          </div>
          <p class="in2-nota">{{ temAmostraSuficiente() ? 'Volume suficiente — os gargalos apontados são confiáveis.' : 'Abaixo do mínimo — as taxas do funil são indicativas.' }}</p>
        </article>
        <article class="in2-card">
          <header><h3>Atenção agora</h3><p>O que merece um olhar neste período</p></header>
          <div class="in2-alerta" *ngFor="let alerta of alertas" [ngClass]="'tom-' + alerta.tom">
            <i class="fas" [ngClass]="alerta.tom === 'neutro' ? 'fa-info-circle' : 'fa-exclamation-triangle'"></i>
            <div><strong>{{ alerta.titulo }}</strong><p>{{ alerta.descricao }}</p></div>
          </div>
        </article>
      </div>
      <div class="in2-diag-extra">
        <article class="in2-card">
          <header><h3>Erros por etapa</h3><p>Onde o pedido morre no fechamento</p></header>
          <div class="in2-erro-row" *ngFor="let etapa of ['Endereço', 'Pagamento', 'Envio do pedido', 'Entrega']">
            <span>{{ etapa }}</span><i><b></b></i><strong>—</strong>
          </div>
          <p class="in2-nota">Eventos de erro em instrumentação.</p>
        </article>
        <article class="in2-card">
          <header><h3>Agora no cardápio</h3><p>Tempo real</p></header>
          <div class="in2-agora"><strong class="in2-num">{{ obtenhaLive() | number }}</strong><span>{{ obtenhaLive() === 1 ? 'visitante agora' : 'visitantes agora' }}</span></div>
          <div class="in2-agora-break">
            <div><strong>—</strong><span>vendo produtos</span></div>
            <div><strong>—</strong><span>na sacola</span></div>
            <div><strong>—</strong><span>no fechamento</span></div>
          </div>
        </article>
      </div>
      </div>
    </section>

    <footer class="in2-action">
      <i class="fas fa-check"></i>
      <p><strong>Ação recomendada:</strong> {{ recomendacao }}</p>
    </footer>
  </ng-container>
</div>
